import { css } from "@emotion/css";
import React from "react";
import { Avatar } from "./";

type Props = {
  users: {
    src?: string;
    username: string;
  }[];
  max?: number;
};
export const AvatarGroup: React.FC<Props> = ({ users, max = 3 }) => {
  const total = users.length;
  const remaining = total - max;
  return (
    <div
      className={css`
        display: flex;
        flex-direction: row;
        align-items: center;
      `}
    >
      {users.slice(0, max).map((user, index) => (
        <Avatar
          key={index}
          username={user.username}
          src={user.src}
          size="1"
          group
        />
      ))}
      {remaining > 0 && <Avatar username={`+ ${remaining}`} size="1" group />}
    </div>
  );
};
